import {
    DarkModeOutlined as DarkIcon,
    LightModeOutlined as LightIcon,
    LogoutOutlined as LogoutIcon,
    MenuOutlined as MenuIcon
} from '@mui/icons-material';
import {
    AppBar,
    Box,
    Drawer,
    IconButton,
    List,
    Toolbar,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { lgb as logo } from 'assets';
import { MenuItem } from 'components';
import { useAuthContext, useMenuContext, useThemeContext } from 'contexts';
import { Fragment } from 'react';

export const Menu = ({ children }) => {
    const theme = useTheme();
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));
    const { toggleTheme } = useThemeContext();
    const { openMenu, handleOpenMenu, optionsMenu, handleOptionsMenu } = useMenuContext();
    const { logout } = useAuthContext();

    return (
        <Fragment>
            <AppBar
                elevation={0}
                sx={{ zIndex: theme.zIndex.modal, bgcolor: '#D97706' }}>
                <Toolbar sx={{ height: theme.spacing(9) }}>
                    {mdDown && (
                        <IconButton
                            color='inherit'
                            onClick={handleOpenMenu}>
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Box
                        component='img'
                        src={logo}
                        alt='The Fish Club'
                        width={180}
                        sx={{ opacity: 0.85 }}
                    />
                    <Typography
                        variant='h6'
                        component='div'
                        sx={{ flexGrow: 1 }}>
                        {/* The Fish Club */}
                    </Typography>
                    <Tooltip title='Sair'>
                        <IconButton
                            color='inherit'
                            onClick={logout}>
                            <LogoutIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title='Alterar Tema'>
                        <IconButton
                            color='inherit'
                            onClick={toggleTheme}>
                            {theme.palette.mode === 'light' ? <DarkIcon /> : <LightIcon />}
                        </IconButton>
                    </Tooltip>
                </Toolbar>
            </AppBar>

            <Drawer
                variant={mdDown ? 'temporary' : 'permanent'}
                open={openMenu}
                onClose={handleOpenMenu}>
                <Box
                    height='100%'
                    width={theme.spacing(28)}
                    paddingTop={theme.spacing(10)}>
                    <List component='nav'>
                        {optionsMenu.map((option) => (
                            <MenuItem
                                key={option.id}
                                icon={option.icon}
                                path={option.path}
                                label={option.label}
                                onClick={mdDown ? handleOpenMenu : null}
                            />
                        ))}
                    </List>
                </Box>
            </Drawer>

            <Box
                height='100vh'
                marginLeft={!mdDown ? theme.spacing(28) : 0}
                paddingTop={theme.spacing(8)}>
                {children}
            </Box>
        </Fragment>
    );
};
